module.exports = __webpack_public_path__ + "static/media/kia-sorento-small.14d636df.jpg";